export default class PaymentIntent {
  constructor(
    public id: string,
    public clientSecret: string,
    public status: string,
    public amount: number | null,
    public currency: string | null,
  ) {}
}
